<div
    class="pb-4 w-full bg-white flex justify-between items-center"
    [ngStyle]="{ 'padding-right.px': scrollBarWidth }">
    <div class="max-w-[150px]">
        <p-datepicker
            [dt]="datePickerToken"
            class="ml-8 md:ml-[50px] calendar-datepicker"
            dateFormat="'{{ dateStringDisplay }}'"
            [(ngModel)]="date"
            [readonlyInput]="true"
            [showIcon]="true"
            icon="pi pi-chevron-down"
            (onSelect)="onSelectDate($event)"
    /></div>

    <div class="flex justify-end items-center">
        <p-select
            severity="secondary"
            class="calendar-header-select"
            [dt]="daysDropdownToken"
            styleClass="text-12 font-inter"
            [options]="numberOfDaysOptions"
            [ngModel]="selectedNumberOfdays"
            (onChange)="onChangeNumberOfDaysToShow($event)"
            optionLabel="label"
            optionValue="value" />

        <p-buttonGroup class="ml-2">
            <p-button
                severity="secondary"
                size="small"
                [dt]="calendarButtonToken"
                styleClass="h-8"
                (onClick)="onClickAdvanceBackwards()">
                <fa-icon [icon]="faChevronLeft"></fa-icon>
            </p-button>

            <p-button
                severity="secondary"
                size="small"
                [dt]="calendarButtonToken"
                styleClass="h-8"
                (onClick)="onClickToday()"
                label="Today" />
            <p-button
                severity="secondary"
                size="small"
                [dt]="calendarButtonToken"
                styleClass="h-8"
                (onClick)="onClickAdvanceForward()">
                <fa-icon [icon]="faChevronRight"></fa-icon>
            </p-button>
        </p-buttonGroup>
    </div>
</div>
